var module = 'main', name = 'main/templates/common/not-found.html', content = "<section class=\"not-found\"><div class=\"not-found-text\" translate=\"page_error\"></div></section>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/templates/common/not-found.html
// module id = 1331
// module chunks = 0